import { CreditCardStoreService } from '@hb/modules/financial-obligations/credit-card/credit-card-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { CoApplicantPipe } from '@hb/modules/global';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { NextButtonComponent } from '@hb/modules';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApAmountInputComponent } from '@ap/input/amount';
import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'credit-card-amount',
    imports: [ApAmountInputComponent, CoApplicantPipe, ApContentPipe, ReactiveFormsModule, NextButtonComponent],
    templateUrl: './credit-card-amount.component.html',
    providers: [
        { provide: GLOBAL_STORE, useExisting: CreditCardStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.CREDIT_CARD_AMOUNT }
    ]
})
export class CreditCardAmountComponent extends GlobalInjectComponent<CreditCardStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(CreditCardStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getAmount()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((amount) => this.store.setAmount(amount));
    }
}
